/* eslint-disable */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  en: {
    Homepage: {
      services1: 'Storage Service',
      instruction1: 'Provide powerful storage service of Mi.com',
      services2: 'After-sale Service',
      instruction2: 'Make complicated After sale Service simple',
      services3: 'Refund Service',
      instruction3: 'Mature and reliable Refund Service',
      services4: 'Other Service',
      instruction4: 'Other Service',
    },
    Content:{
      tittle1: 'Business Cooperation',
      subtittle11: 'Scope of business:',
      subcontent11: 'XiaomI open platform will open some API related to e-commerce services,including orders,warehousing,after-sales service,customer service,etc. If your company have business contacts with Xiaomi, you need to use some of these services and contact us.',
      subtittle12: 'E-mail:',
      subcontent12: 'OPEN-API@xiaomi.com',

      tittle2: 'problem',
      subtittle21: 'technical question:',
      subcontent21: 'If you have any technical problems with Xiaomi open platform,such as: API application, SDK usage,access rights,etc. Please contact us.',
      subtittle22: 'E-mail:',
      subcontent22: 'OPEN-API@xiaomi.com',

      tittle3: 'Access Application',
      subtittle31: 'Application question:',
      subcontent31: 'If you have any questions about the application process, such as to be developer, application  cteation and API, please contact us.',
      subtittle32: 'E-mail:',
      subcontent32: 'OPEN-API@xiaomi.com',

      tittle4: 'Open Plat Communicaton Group',
      subtittle4: 'QQ：226281810'
    },
    dashboard: {
      ApiListTittle1: 'Business Scenario',
      ApiListTittle2: 'Description',
      ApiListTittle3: 'Operation',
      AppListStatus0: 'Apply',
      AppListStatus1: 'Pending',
      AppListStatus2: 'Passed',
      AppListStatus3: 'Rejected',

      PageMyApplyStatus0: 'Pending',
      PageMyApplyStatus1: 'Passed',
      PageMyApplyStatus2: 'Rejected',
      AppListData: 'no data',
      view: 'view',
      edit: 'edit',
      delete: 'delete',
      appListTittle1: 'Name',
      appListTittle2: 'Status',
      appListTittle3: 'Description',
      appListTittle4: 'Operation',
      appListStatus: 'passed',
      appListDelete: 'Are you sure to delete',
      appListCancel: 'Cancel',
      appListSave: 'Sure',

      appNavList1: 'Application Overview',
      appNavList2: 'API Apply',
      appNavList3: 'SDK Manage',
      // appNavList4: 'Flux Statistics',
      appNavList5: 'The Log View',
      appNavList6: 'Call details',

      navLink1: 'Application List',
      navLink2: 'My Request',
      navLink3: 'Sandbox Tools',
      noApiData: 'You have not called any API yet, there is no statistics',
      pageAddLabel1: 'Application Name',
      pageAddLabel2: 'Application Introduction',
      pageAddLabel3: 'IP Write List(Split by Semicolon)',
      pageAddLabel3Tips:'Multiple IP are separated by semicolons, and the segments are recorded in a mask format, such as: 10.236.134.0/24',
      pageAddLabel4: 'Call Quota per Day',
      pageAddInvalid1: 'Do not be empty',
      pageAddInvalid2: 'Not the correct IP address',
      pageAddInvalid3: 'Less than or equal to 1000000',
      pageAddSubmit: 'Submit',
      selectOption: 'Please select a scene and API to see the statistical data',
      pageAppDetail1: 'Visit Flux',
      pageAppDetail2: 'API Call Count',
      pageAppDetail3: 'API Error Rate',
      newtab: 'New application',

      sandboxLabel1: 'API Group',
      sandboxLabel2: 'API Name',
      sandboxLabel3: 'API Environment',
      sandboxLabel4: 'API Request Parameters',
      sandboxLabel5: 'Format',
      sandboxResponse: 'API Response',

      sdkTittle1: 'Build SDK',
      sdkTittle2: 'Download SDK',
      sdkSuccess: 'The SDK is being generated. It will take about 5 minutes. Please be patient and refresh the page.',
      sdkBuidTime: 'The birth time',

      trafficStatContent: 'Diagram',
      trafficStatTittle2: 'Error count',

      pageUpdateCancel: 'Cancel',
      pageUpdateSave: 'Save',

      applyListTh1: 'AppName',
      applyListTh2: 'Scenario Name',
      applyListTh3: 'Apply Time',
      applyListTh4: 'Apply Status',
      applyListStatus0: 'Approved',
      applyListStatus1: 'Failed',
      applyListData: 'No Data',

      pageLogViewSelected: 'Please Select',
      pageLogViewSelectedScene: '﻿Please select the scene first',
      pageLogViewSelectedAPI: '﻿Please select the API',
      pageLogViewSelectedTime: '﻿Please select the time',
      pageLogViewSearchEmpty: 'The search results are empty',
      pageLogViewStartTime: 'Please select the time frame',
      pageLogViewAbnormalShow: 'Display exception only',
      pageLogViewClientIp: 'Client IP',
      pageLogViewCode: 'Code',
      pageLogViewSearchReminder: 'Please Search',
      pageLogViewSearchBtn: 'Search',
      pageLogViewSearchResult: 'The Search Results',
      pageLogViewSearchResult1: 'Total',
      pageLogViewSearchResult2: '',
      pageLogViewPrePage: 'Prev',
      pageLogViewNextPage: 'Next',

      pageCallChart1: 'Api call count',
      pageCallChart2: 'Api call maximum time consuming',
      pageCallChart3: 'Api call error rate',
      pageCallChart4: 'API error code distribution',
      oneHour: 'One hour',
      oneDay: 'One day',
      tenDays: 'Ten days',
    },
    API: {
      ApiListTittle1: 'API Name',
      ApiListTittle2: 'API Description',
      sideNavTittle1: 'API Group',
      sideNavTittle2: 'Business Scenario',
    },
    Register: {
        name: 'Name',
        phone: 'Phone Number',
        area: 'Area Number',
        MesCode: 'Verification Code',
        sendMesCode: 'sendMesCode',
        mail: 'Email',
        companyName: 'Company Name',
        adress: 'Exact Address',
        country:'Country',
        selectCountry: 'Please select country ...',
        option: 'Please select ...',
        detailAdress: 'Detail Adress',
        agree: 'I agree with',
        agreement: '《Developer agreement for the xiaomi web development platform》',
        submit: 'Submit',
        confirmTittle: 'You have become a developer through the application.',
        confirmdesc: 'Try to create your applications immediately',
        milogin: 'XiaoMi Account Login',
        devapp: 'Developers Application',
        proau: 'Profile Audit',
    },
  },
  zh: {
    Register: {
        name: '开发者姓名',
        phone: '手机号码',
        area: '区号',
        MesCode: '验证码',
        sendMesCode: '发送验证码',
        mail: '企业邮箱',
        companyName: '公司名称',
        adress: '公司地址',
        country: '国家',
        selectCountry: '请选择国家',
        option: '请选择',
        detailAdress: '详细地址',
        agree: '我已点击阅',
        agreement: '《小米网开发平台开发者协议》',
        submit: '提交',
        confirmTittle: '申请通过，您已成为开发者',
        confirmdesc: '立即创建属于您的应用',
        milogin: '小米账号登录',
        devapp: '开发者申请',
        proau: '资料审核',
    },
    Homepage: {
      services1: '仓储服务',
      instruction1: '提供小米网强大的仓储物流服务',
      services2: '售后服务',
      instruction2: '让复杂的售后业务变的简单',
      services3: '退款服务',
      instruction3: '成熟、可靠的退款服务',
      services4: '其他服务',
      instruction4: '其他服务',
    },
    Content:{
      tittle1: '商务合作',
      subtittle11: '业务范围:',
      subcontent11: '小米网开放平台会开放一些与电商服务有关的API，包括订单、仓储、售后、客服等。如您的公司和小米有商业来往，需要使用上述的一些服务，可与我们联系。',
      subtittle12: '联系邮箱:',
      subcontent12: 'OPEN-API@xiaomi.com',

      tittle2: '使用问题',
      subtittle21: '技术问题:',
      subcontent21: '如您在使用小米网开放平台遇到任何技术问题，比如：API申请、SDK使用、访问权限等。请与我们联系。',
      subtittle22: '联系邮箱:',
      subcontent22: 'OPEN-API@xiaomi.com',

      tittle3: '接入申请',
      subtittle31: '申请疑问:',
      subcontent31: '在您申请成为开发者、创建应用、API等过程中，若对申请流程有任何疑问，请与我们联系。',
      subtittle32: '联系邮箱:',
      subcontent32: 'OPEN-API@xiaomi.com',

      tittle4: '开放平台交流群',
      subtittle4: 'QQ群：226281810',
    },
    dashboard: {
      ApiListTittle1: '业务场景',
      ApiListTittle2: '描述',
      ApiListTittle3: '操作',
      AppListStatus0: '申请',
      AppListStatus1: '审核中',
      AppListStatus2: '审核通过',
      AppListStatus3: '已拒绝',

      PageMyApplyStatus0: '审核中',
      PageMyApplyStatus1: '审核通过',
      PageMyApplyStatus2: '审核拒绝',

      AppListData: '暂无数据',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      appListTittle1: '名称',
      appListTittle2: '状态',
      appListTittle3: '描述',
      appListTittle4: '操作',
      appListStatus: '已通过',
      appListDelete: '确认删除',
      appListCancel: '取消',
      appListSave: '确认',

      appNavList1: '应用概览',
      appNavList2: 'API申请',
      appNavList3: 'SDK管理',
      // appNavList4: '流量统计',
      appNavList5: '日志查看',
      appNavList6: '调用详情',

      navLink1: '应用列表',
      navLink2: '我的申请',
      navLink3: '沙箱测试',
      noApiData: '您尚未调用过任何API，暂无统计数据',
      pageAddLabel1: '应用名称',
      pageAddLabel2: '描述',
      pageAddLabel3: 'IP 白名单',
      pageAddLabel3Tips:'多个ip请使用分号隔开,网段使用掩码格式记录,如:10.236.134.0/24',
      pageAddLabel4: '流量',
      pageAddInvalid1: '不能为空',
      pageAddInvalid2: '不是正确的ip地址',
      pageAddInvalid3: '不能大于1000000',
      pageAddSubmit: '提交',

      pageAppDetail1: '访问流量',
      pageAppDetail2: 'API调用次数',
      pageAppDetail3: 'API错误率',
      newtab: '新建应用',

      sandboxLabel1: 'API 组：',
      sandboxLabel2: 'API 名称',

      sandboxLabel3: '数据环境：',
      sandboxLabel4: 'API请求参数',
      sandboxLabel5: '参数格式',
      sandboxResponse: 'API 返回结果',

      sdkTittle1: '构建 SDK',
      sdkTittle2: '下载 SDK',
      sdkSuccess: 'SDK 正在生成，这大概需要 5 分钟，请耐心等待，刷新页面。',
      sdkBuidTime: '生成时间',

      trafficStatContent: '图表',
      trafficStatTittle2: '错误数统计',

      pageUpdateCancel: '取消',
      pageUpdateSave: '保存',

      applyListTh1: '应用名称',
      applyListTh2: '场景名称',
      applyListTh3: '申请时间',
      applyListTh4: '申请状态',
      applyListStatus0: '申请成功',
      applyListStatus1: '未通过',
      applyListData: '暂无数据',
      selectOption: '请选择场景与API以查看相应统计数据',
      pageLogViewSelected: '请选择',
      pageLogViewSelectedScene: '﻿请先选择场景',
      pageLogViewSelectedAPI: '﻿请选择API',
      pageLogViewSelectedTime: '﻿请选择时间',
      pageLogViewSearchEmpty: '搜索结果为空',
      pageLogViewStartTime: '请选择时间段',
      pageLogViewAbnormalShow: '只显示异常',
      pageLogViewClientIp: 'client_ip',
      pageLogViewCode: 'code',
      pageLogViewSearchReminder: '请搜索',
      pageLogViewSearchBtn: '搜索',
      pageLogViewSearchResult: '搜索结果',
      pageLogViewSearchResult1: '共',
      pageLogViewSearchResult2: '条',
      pageLogViewPrePage: '上一页',
      pageLogViewNextPage: '下一页',

      pageCallChart1: 'Api调用次数',
      pageCallChart2: 'Api调用最大耗时',
      pageCallChart3: 'Api调用错误率',
      pageCallChart4: 'API错误code分布',
      oneHour: '1小时',
      oneDay: '1天',
      tenDays: '10天',
    },
    API: {
      ApiListTittle1: '名称',
      ApiListTittle2: '描述',
      sideNavTittle1: 'API 组',
      sideNavTittle2: '使用场景',
    }
  },
};

const i18n = new VueI18n({
  locale: 'zh',
  messages,
});
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js